import * as actions from 'app/actions/account';
import * as client from 'app/api/contentful-client';
import { GENERIC_SUBMIT_ERROR } from 'app/strings';
import { SubmissionError } from 'redux-form';

function validationErrors(err) {
  const { data } = err;
  const { errors } = data || {};
  // If there was an error with the email address, return the data block and
  // let the reducer show a special alert to the user with extended instructions
  if (errors.email) {
    return data;
  }
  throw new SubmissionError(errors || { _error: GENERIC_SUBMIT_ERROR });
}

export const createAccount = values => ({
  promise: http => http.post('/user/v1/profile', values).catch(validationErrors),
  events: ['PROMISE_PENDING', actions.CREATE_ACCOUNT, 'PROMISE_ERROR'],
});


export const fetchCreateAccountPage = () => ({
  promise: () => client.getPage('create-account-page'),
  events: ['PROMISE_PENDING', actions.SET_CREATE_ACCOUNT_PAGE, 'PROMISE_ERROR'],
});



// WEBPACK FOOTER //
// ./app/api/account-api.js